//css-------------------
import "@/css/home/database_search.scss";



//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { sidenav_toggle } from "@/js/share/components/_sidenav.js";
import { getUrlParameter } from "@/js/share/components/_globeVar.js";


//npm lib  
import $ from "jquery";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
            form_show: true,
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
            //
        });
    },
    methods: {
        ...baseMethods,
        sidenav_toggle,
        form_toggle() {
            this.form_show = !this.form_show;
            if (this.form_show) {
                $('.database_form_box').slideDown();
            } else {
                $('.database_form_box').slideUp();
            }
        },
        form_submit() {
            location.href = '?title=' + $('input[name=title]').val() + '&title_en=' + $('input[name=title_en]').val() + '&year=' + $('select[name=year]').val() + '&release_year=' + $('input[name=release_year]').val() + '&team_name=' + $('input[name=team_name]').val() + '&team_name_en=' + $('input[name=team_name_en]').val() + '&country=' + $('select[name=country]').val();
        },
    },
}).mount("#app");

